export default "__VITE_ASSET__f8d2f90e__"